import { Controller, useFormContext } from "react-hook-form";
import { Form, Input } from "semantic-ui-react";

import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import type { FormFieldProps, InputOnChangeData, InputProps } from "semantic-ui-react";

type ShallowPath<T> = keyof T & string;

type FormArrayInputProps<T extends FieldValues> = {
  fieldArrayName: ShallowPath<T>;
  index: number;
  fieldKey: string;
  inputProps?: InputProps;
  formFieldProps?: FormFieldProps;
};

export const FormArrayInput = <T extends FieldValues>({ fieldArrayName, formFieldProps, index, fieldKey, inputProps }: FormArrayInputProps<T>) => {
  const methods = useFormContext<T>();
  const path = `${fieldArrayName}.${index}.${fieldKey}` as const;

  const handleOnChange = (_: React.ChangeEvent<HTMLInputElement>, { value }: InputOnChangeData, field: ControllerRenderProps<T, Path<T>>) => {
    if (inputProps?.onChange) return inputProps.onChange(_, { value });
    field.onChange(inputProps?.type === "number" ? parseFloat(value) : value);
  };

  return (
    <Controller
      name={path as Path<T>}
      control={methods.control}
      render={({ field, fieldState: { invalid, isTouched } }) => (
        <Form.Field {...formFieldProps} error={invalid && isTouched}>
          <Input {...field} {...inputProps} onChange={(_, data) => handleOnChange(_, data, field)} />
        </Form.Field>
      )}
    />
  );
};
